import { useApi } from '.';

export const useSaveEconomicIndexersFile = () => useApi(`/v2/economic-indexers/save`, 'POST', {}, {}, true);

export const useGetEconomicIndexersFile = (documentId) => useApi(`/v2/economic-indexers/${documentId}`, 'GET', {}, {}, true);